const WISHLIST_BUTTON_SELECTOR = '[data-wishlist-button]';
const ACTIVE_CLASS = 'is-active';
const LOADING_CLASS = 'is-loading';
const WISHLIST_EVENT_NAME = 'wishlist:changed';
const WISHLIST_LOGIN_DIALOG_SELECTOR = '[data-wishlist-login-dialog]';

document.addEventListener('click', async (event) => {
  const target = event.target;

  if (!(target instanceof Element)) {
    return;
  }

  const button = target.closest(WISHLIST_BUTTON_SELECTOR);

  if (!(button instanceof HTMLButtonElement)) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  if (button.classList.contains(LOADING_CLASS)) {
    return;
  }

  if (button.dataset.customerLoggedIn !== 'true') {
    const loginDialog = document.querySelector(WISHLIST_LOGIN_DIALOG_SELECTOR);

    if (loginDialog instanceof HTMLElement && typeof loginDialog.showDialog === 'function') {
      loginDialog.showDialog();
    }

    return;
  }

  const productId = button.dataset.productId;
  const isActive = button.classList.contains(ACTIVE_CLASS);
  const insertUrl = button.dataset.proxyInsertUrl || button.dataset.proxyUrl || '/apps/api/customers/wishlist-list/insert';
  const removeUrl = button.dataset.proxyRemoveUrl || '/apps/api/customers/wishlist-list/remove';
  const proxyUrl = isActive ? removeUrl : insertUrl;
  const listName = button.dataset.listName;

  if (!productId) {
    console.error('Wishlist button is missing data-product-id.');
    return;
  }

  setButtonState(button, { loading: true });

  try {
    const response = await fetch(proxyUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        product_id: productId,
        ...(listName ? { list_name: listName } : {}),
      }),
    });

    if (!response.ok) {
      const errorPayload = await response.json().catch(() => null);

      throw new Error(errorPayload?.error || errorPayload?.message || 'Wishlist request failed.');
    }

    setButtonState(button, { active: !isActive });
    document.dispatchEvent(
      new CustomEvent(WISHLIST_EVENT_NAME, {
        detail: {
          action: isActive ? 'remove' : 'insert',
          productId,
          button,
        },
      })
    );
  } catch (error) {
    console.error(`Error ${isActive ? 'removing product from' : 'adding product to'} wishlist:`, error);
    setButtonState(button, { active: isActive });
  } finally {
    button.classList.remove(LOADING_CLASS);
  }
});

function setButtonState(button, { active = false, loading = false }) {
  button.classList.toggle(ACTIVE_CLASS, active);
  button.classList.toggle(LOADING_CLASS, loading);
  button.setAttribute('aria-pressed', active ? 'true' : 'false');
  button.setAttribute('aria-busy', loading ? 'true' : 'false');
}
